import { defineNuxtPlugin } from 'nuxt/app'
import * as Sentry from '@sentry/vue'
import { getRelease } from './helpers'
import { getEnvSync } from '~/plugins/config/loadEnvConfig'

export default defineNuxtPlugin((nuxtApp) => {
  const { $envConfig } = nuxtApp
  const release = getRelease()

  if (release) {
    const env = getEnvSync()
    const isStaging = env === 'stage'
    const isProd = env === 'prod'
    const isStagingOrProd = isStaging || isProd
    Sentry.init({
      // ensure Vue errors are not swallowed by Nuxt error handling
      Vue: nuxtApp.vueApp,
      dsn: $envConfig.SENTRY_DSN,
      // enable tracing and replay on staging and prod
      integrations: isStagingOrProd
        ? [Sentry.browserTracingIntegration(), Sentry.replayIntegration()]
        : [],
      tracePropagationTargets: [...$envConfig.hostnames, /^\//],
      // rename to staging to match sentry environment
      environment: isStaging ? 'staging' : env,
      release,
      sampleRate: 1,
      // Capture 1% of transactions for performance monitoring.
      tracesSampleRate: 0.01,
      // Capture Replay for 0% of all normal sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0
    })
  }
})
